// extracted by mini-css-extract-plugin
module.exports = {"root":"x_M","blurBackground":"x_bD","wrapper":"x_bF","branding":"x_bG","toggleNavButton":"x_bH"};